import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/es'; // Importar el locale de español
import 'react-big-calendar/lib/css/react-big-calendar.css'; // Importar el estilo
import Modal from 'react-modal';
import './Citas.css';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye } from '@fortawesome/free-solid-svg-icons';
import { fetchUsuario, getUsuario } from '../user';
import Select from 'react-select';
import baseURL from '../url';
import { tz } from 'dayjs';
import Helper from '../../Helpers/helpers';
import AsyncSelect from 'react-select/async';

import TurnoModal from '../Modals/TurnoModal';
import enviarPdfAlServidor from '../Dias/DescargarCitaPdf';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');

// Configurar moment.js para usar el idioma español
moment.locale('es'); // Establecer el idioma a español
const localizer = momentLocalizer(moment);

// Mensajes en español para las vistas
const messages = {
    today: 'Hoy',
    previous: 'Anterior',
    next: 'Siguiente',
    month: 'Mes',
    week: 'Semana',
    day: 'Día',
    agenda: 'Agenda',
    date: 'Fecha',
    time: 'Hora',
    event: 'Evento',
};

export default function Citas() {
    const color1 = getComputedStyle(document.documentElement).getPropertyValue('--color1');
    const [turnos, setTurnos] = useState([]);
    const [turnoSeleccionado, setTurnoSeleccionado] = useState(null); // Estado para el turno seleccionado
    const [modalIsOpen, setModalIsOpen] = useState(false); // Estado para abrir o cerrar el modal

    const [nombre, setNombre] = useState("");
    const [telefono, setTelefono] = useState("");
    const [motivoInactivo, setMotivoInactivo] = useState([]);

    const [nuevaFecha, setNuevaFecha] = useState("");
    const [periodicidad, setPeriodicidad] = useState("");

    const [nuevaHoraInicio, setNuevaHoraInicio] = useState("");
    const [nuevaHoraFin, setNuevaHoraFin] = useState("");

    const [nuevoComentario, setNuevoComentario] = useState("");
    const [comentarioActualizado, setComentarioActualizado] = useState(0); //se usa para saber cuando se agrego un comentario
    const [cancelarActualizado, setCancelarActualizado] = useState(0); //se usa para saber cuando se hizo una cancelacion

    const [nuevoEstado, setNuevoEstado] = useState('');
    const [servicios, setServicios] = useState([]);
    const [servicioSeleccionado, setServicioSeleccionado] = useState(null); // Establecer el servicio seleccionado por defecto
    const [serviciosFiltrados, setServiciosFiltrados] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [selectedEstados, setSelectedEstados] = useState(['pendiente']);
    const [terapeutas, setTerapeutas] = useState([]);
    const [terapeutaSeleccionado, setTerapeutaSeleccionado] = useState('');
    const [salas, setSalas] = useState([]);
    const [salaSeleccionada, setSalaSeleccionada] = useState('');
    const [categorias, setCategorias] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('');

    const [citasSeleccionadas, setCitasSeleccionadas] = useState([]); //seleccionadas para cancelarse

    const [categoriasFiltradas, setCategoriasFiltradas] = useState([]);


    useEffect(() => {
        cargarTurnos();
        cargarServicios();
        cargarUsuarios();
        cargarSalas();
        cargarCategorias();
    }, []);
    //Trae usuario logueado-----------------------------
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);
    const usuarioLegued = getUsuario();

    // Establecer Ceseco principal por defecto cuando hay filtro disponible (admin, direccion)
    useEffect(() => {
        if (categorias.length > 0 && usuarioLegued && categoriasFiltradas.length === 0) {
            if ((usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'direccion')) {
                const cesecoPrincipal = usuarioLegued.cesecoPrincipal || 
                                       usuarioLegued.categorias?.find(c => c.esPrincipal === 1 || c.esPrincipal === '1') ||
                                       (usuarioLegued.idCategoria && categorias.find(c => c.idCategoria === usuarioLegued.idCategoria));
                
                if (cesecoPrincipal) {
                    const cesecoEnLista = categorias.find(c => 
                        c.idCategoria === cesecoPrincipal.idCategoria || c.idCategoria === cesecoPrincipal
                    );
                    
                    if (cesecoEnLista) {
                        setCategoriasFiltradas([{ value: cesecoEnLista.idCategoria, label: cesecoEnLista.categoria }]);
                    }
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categorias.length, usuarioLegued?.idCategoria, usuarioLegued?.cesecoPrincipal?.idCategoria]);

    // Establecer servicio principal por defecto cuando se carguen los servicios
    useEffect(() => {
        if (servicios.length > 0 && usuarioLegued && serviciosFiltrados.length === 0) {
            // Buscar el servicio principal del usuario
            const servicioPrincipal = usuarioLegued.servicioPrincipal || 
                                     usuarioLegued.servicios?.find(s => s.esPrincipal === 1 || s.esPrincipal === '1') ||
                                     (usuarioLegued.idServicio && servicios.find(s => s.idServicio === usuarioLegued.idServicio));
            
            if (servicioPrincipal) {
                const servicioEnLista = servicios.find(s => {
                    // Si hay Cesecos filtrados, verificar que el servicio pertenezca a uno de ellos
                    if (categoriasFiltradas.length > 0) {
                        const perteneceACesecoFiltrado = categoriasFiltradas.some(c => c.value === s.idCategoria);
                        if (!perteneceACesecoFiltrado) return false;
                    } else {
                        // Verificar que el servicio pertenezca a uno de los Cesecos asignados
                        const perteneceACeseco = usuarioLegued?.idCategorias?.includes(s.idCategoria) ||
                                                s.idCategoria === usuarioLegued.idCategoria;
                        if (!perteneceACeseco) return false;
                    }
                    
                    // Para coord_ceseco y secretaria: todos los servicios de sus Cesecos
                    if (usuarioLegued?.rol === 'coord_ceseco' || usuarioLegued?.rol === 'secretaria') {
                        return s.idServicio === servicioPrincipal.idServicio || s.idServicio === servicioPrincipal;
                    }
                    
                    // Para coord_programa: solo servicios asignados directamente
                    if (usuarioLegued?.rol === 'coord_programa') {
                        return (s.idServicio === servicioPrincipal.idServicio || s.idServicio === servicioPrincipal) &&
                               (usuarioLegued?.idServicios?.includes(s.idServicio) || usuarioLegued?.idServicio === s.idServicio);
                    }
                    
                    return s.idServicio === servicioPrincipal.idServicio || s.idServicio === servicioPrincipal;
                });
                
                if (servicioEnLista) {
                    setServiciosFiltrados([{ value: servicioEnLista.idServicio, label: servicioEnLista.titulo }]);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [servicios.length, usuarioLegued?.idServicio, usuarioLegued?.servicioPrincipal?.idServicio, categoriasFiltradas.length]);

    const cargarTurnos = () => {
        return fetch(`${baseURL}/turnoGet.php?idUser=${usuarioLegued.idUsuario}`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const turnosConDias = data.turnos?.map(turno => ({
                    ...turno,
                    dias: JSON.parse(turno.dias)
                })) || [];

                setTurnos(turnosConDias);
                return turnosConDias;
            })
            .catch(error => {
                console.error('Error al cargar turnos:', error);
                return [];
            });
    };

    const cargarServicios = () => {
        fetch(`${baseURL}/serviciosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setServicios(data.servicios || []);
                if (data.servicios && data.servicios.length > 0) {
                    setServicioSeleccionado(data.servicios[0].idServicio); // Selecciona el primer servicio por defecto
                }
            })
            .catch(error => console.error('Error al cargar servicios:', error));
    };

    const cargarUsuarios = () => {
        fetch(`${baseURL}/usuariosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTerapeutas(data.usuarios.filter(usuario => (usuario.rol === "terapeuta")) || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarSalas = () => {
        fetch(`${baseURL}/salasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setSalas(data.salas || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const categoriasOrdenadas = (data?.categorias || [])?.sort((a, b) => a.orden - b.orden);
                setCategorias(categoriasOrdenadas);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const handleSelectEvent = (event) => {
        // Filtrar el turno seleccionado por su idTurno
        const turnoSeleccionado = turnos.find(item => item.idTurno === event.idTurno);

        if (turnoSeleccionado) {
            // if (selectedTab === 'citasPorAutorizar') {
            //     alertAsignarSala(turnoSeleccionado);
            // } else {
            setModalIsOpen(true);
            // }
            setTurnoSeleccionado(turnoSeleccionado); // Establecer el turno seleccionado
            setTerapeutaSeleccionado(turnoSeleccionado.idTerapeuta);
            setSalaSeleccionada(turnoSeleccionado.idSala);
            // setModalIsOpen(true); // Abrir el modal
        }
    };

    const handleCloseModal = () => {
        setModalIsOpen(false); // Cerrar el modal
    };

    // const handleSelectSlot = (slotInfo) => {
    //     // Mostrar un mensaje cuando se selecciona un rango de fechas
    //     alert(`Seleccionado el rango: ${slotInfo.start} - ${slotInfo.end}`);
    // };

    // Inicialización de servicios del usuario logueado
    const serviciosUsuario = usuarioLegued?.rol === "admin"
        ? servicios
        : servicios.filter(servicio => servicio.idUsuario === usuarioLegued?.idUsuario);

    // Selección inicial del servicio
    const servicioSeleccionadoInicial = servicioSeleccionado || serviciosUsuario[0]?.idServicio;

    const handleFilterChange = (e) => {
        setFilterText(e.target.value.toLowerCase());
    };

    const filteredTurnos = Helper.filterTurnosByEstados({
        turnos: turnos?.filter(turno => {
            // Filtro por servicios seleccionados
            const pasaFiltroServicios = serviciosFiltrados.length === 0 || 
                serviciosFiltrados.map(servicio => servicio.value).includes(turno?.idServicio);
            
            // Filtro por categorías seleccionadas
            const pasaFiltroCategorias = categoriasFiltradas.length === 0 || 
                categoriasFiltradas.map(categoria => categoria.value).includes(turno?.idCategoriaSala);
            
            // Para coord_ceseco, coord_programa y secretaria: si no hay filtros, mostrar turnos de todos sus Cesecos asignados
            if ((usuarioLegued?.rol === 'coord_ceseco' || 
                 usuarioLegued?.rol === 'coord_programa' || 
                 usuarioLegued?.rol === 'secretaria') && 
                serviciosFiltrados.length === 0 && categoriasFiltradas.length === 0) {
                const tieneAcceso = usuarioLegued?.idCategorias?.includes(turno?.idCategoriaSala) ||
                                   turno?.idCategoriaSala === usuarioLegued?.idCategoria;
                return tieneAcceso;
            }
            
            return pasaFiltroServicios && pasaFiltroCategorias;
        }),
        selectedEstados,
        usuarioLegued,
        filterText,
        serviciosFiltrados: [] // ya filtrado arriba
    });

    // turnos?.filter(
    //     (turno) =>
    //         turno?.nombre?.toLowerCase()?.includes(filterText) ||
    //         turno?.dni?.includes(filterText) ||
    //         turno?.telefono?.includes(filterText)
    // );

    const CustomEvent = ({ event }) => {
        const horaInicio = moment(event.start).format('HH:mm');
        const horaFin = moment(event.end).format('HH:mm');
        const color = event.style?.color || 'black'; // Usa el color definido en el evento

        return (
            <div style={{ whiteSpace: 'normal', color }}>
                <div style={{ fontSize: '0.8em' }}>
                    {horaInicio} - {horaFin}
                </div>
                <div style={{ fontSize: '0.8em' }}>
                    <strong>{event.title}</strong>
                </div>
            </div>
        );
    };

    // Filtro de turnos ajustado para admin y colaborador
    const events = filteredTurnos
        // ?.filter(item => {
        //     if (!usuarioLegued || !usuarioLegued.idUsuario) {
        //         // Sin usuario logueado: mostrar todos los turnos
        //         return servicioSeleccionado ? item.idServicio === servicioSeleccionado : true;
        //     }

        //     if (usuarioLegued.rol === "admin") {
        //         // Si es admin: mostrar todos los turnos y los del servicio seleccionado
        //         return servicioSeleccionado ? item.idServicio === servicioSeleccionado : true;
        //     }

        //     if (usuarioLegued.rol !== "admin") {
        //         // Si es colaborador: mostrar solo los turnos vinculados a sus servicios
        //         const serviciosFiltrados = serviciosUsuario.map(s => s.idServicio);
        //         return serviciosFiltrados.includes(item.idServicio) &&
        //             item.idServicio === servicioSeleccionadoInicial;
        //     }


        //     return false; // Fallback de seguridad
        // })
        .map(item => {
            const dias = item.dias ?? [];
            return dias?.map(dia => {
                const colors = Helper.getTurnoColors(item);

                return {
                    title: `${item.nombre} - ${item.servicio}`,
                    start: new Date(dia.dia + "T" + dia.horaInicio),
                    end: new Date(dia.dia + "T" + dia.horaFin),
                    allDay: false,
                    idTurno: item.idTurno,
                    estado: item.estado,
                    style: { backgroundColor: colors[0], color: colors[1] },
                };
            });
        })
        .flat() ?? [];

    useEffect(() => {
        // Actualiza el valor del select cuando cambia el estado nuevoEstado
        setNuevoEstado(turnoSeleccionado?.estado);
    }, [turnoSeleccionado]);

    const handleUpdateText = async (idTurno) => {


        if (nuevoEstado == 'Asignado') {
            //crear pdf
            const detallesTurno = {
                idTurno: idTurno,
                servicio: turnoSeleccionado.servicio,
                dia: dayjs(turnoSeleccionado.dias[0].dia).format('dddd'),
                fecha: dayjs(turnoSeleccionado.dias[0].dia).format('dddd, D [de] MMMM [de] YYYY'),
                horarioInicio: turnoSeleccionado.dias[0].horaInicio,
                horarioFin: turnoSeleccionado.dias[0].horaFin,
                nombre,
                telefono,
                categoria: turnoSeleccionado.nombreCategoria,
                ubicacionTienda: turnoSeleccionado.mapaUrlTienda,
            };
            enviarPdfAlServidor(detallesTurno);
        }


        try {

            const payload = {
                idTurno: idTurno,
                nombre: nombre,
                telefono: telefono,
                idServicio: Number(servicioSeleccionado),
                idTerapeuta: terapeutaSeleccionado ? terapeutaSeleccionado : null,
                idSala: salaSeleccionada ? salaSeleccionada : null,
                estado: nuevoEstado !== '' ? nuevoEstado : turnoSeleccionado.estado,
                motivo_inactivo: motivoInactivo != '' ? motivoInactivo : null
            };


            fetch(`${baseURL}/turnoPut.php?idTurno=${idTurno}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
                .then(response => response.json())
                .then(async (data) => {
                    if (data.error) {
                        Swal.fire(
                            'Error!',
                            data.error,
                            'error'
                        );
                    } else {

                        Swal.fire(
                            'Actualización exitosa',
                            data.mensaje,
                            'success'
                        );
                        const nuevosTurnos = await cargarTurnos();
                        const turnoSeleccionado = nuevosTurnos.find(item => item.idTurno === idTurno);
                        setTurnoSeleccionado({ ...turnoSeleccionado });
                    }
                })
                .catch(error => {
                    Swal.fire(
                        'Error!',
                        error.message,
                        'error'
                    );
                });
        } catch (error) {
            Swal.fire(
                'Error!',
                error.message,
                'error'
            );
        }
    };

    const handleUpdateDate = async (idTurno) => {
        try {

            const payload = {
                idTurno: idTurno,
                nuevaFecha: nuevaFecha,
                periodicidad: periodicidad,
                nuevaHoraInicio: nuevaHoraInicio,
                nuevaHoraFin: nuevaHoraFin
            };

            fetch(`${baseURL}/turnoFechaHoraPut.php?idTurno=${idTurno}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
                .then(response => response.json())
                .then(async (data) => {
                    if (data.error) {
                        Swal.fire(
                            'Error!',
                            data.error,
                            'error'
                        );
                    } else {
                        Swal.fire(
                            'Actualización exitosa',
                            data.mensaje,
                            'success'
                        );
                        const nuevosTurnos = await cargarTurnos();
                        const turnoSeleccionado = nuevosTurnos.find(item => item.idTurno === idTurno);
                        setTurnoSeleccionado({ ...turnoSeleccionado });
                    }
                })
                .catch(error => {
                    Swal.fire(
                        'Error!',
                        error.message,
                        'error'
                    );
                });
        } catch (error) {
            Swal.fire(
                'Error!',
                error.message,
                'error'
            );
        }
    };

    const handleInsertComment = async (idTurno, tipo) => {
        if (tipo === 3 && nuevoEstado != 'Asignado') {
            Swal.fire('Error!', 'Para poder programar citas el estado de la cita debe ser Asignado', 'error');
        } else {
            try {

                const formData = new FormData();
                formData.append('idTurno', idTurno);
                formData.append('idTerapeuta', usuarioLegued.idUsuario);
                formData.append('comentario', nuevoComentario);
                formData.append('tipo_de_comentario', tipo);
                formData.append('periodicidad', periodicidad);

                fetch(`${baseURL}/comentarioPost.php`, {
                    method: 'POST',
                    body: formData,
                })
                    .then(response => response.json())
                    .then(async (data) => {
                        if (data.error) {
                            Swal.fire(
                                'Error!',
                                data.error,
                                'error'
                            );
                        } else {
                            if (tipo === 4) {
                                //creamos el pdf
                                const idTurnoNuevo = Number(data.turno);
                                const nuevaFecha = data.fecha;

                                const detallesTurno = {
                                    idTurno: idTurnoNuevo,
                                    servicio: turnoSeleccionado.servicio,
                                    dia: dayjs(nuevaFecha).format('dddd'),
                                    fecha: dayjs(nuevaFecha).format('dddd, D [de] MMMM [de] YYYY'),
                                    horarioInicio: turnoSeleccionado.dias[0].horaInicio,
                                    horarioFin: turnoSeleccionado.dias[0].horaFin,
                                    nombre: turnoSeleccionado.nombre,
                                    telefono: turnoSeleccionado.telefono,
                                    categoria: turnoSeleccionado.nombreCategoria,
                                    ubicacionTienda: turnoSeleccionado.mapaUrlTienda,
                                };
                                enviarPdfAlServidor(detallesTurno);
                            }
                            if (tipo === 3) {
                                //creamos los pdfs
                                const idsTurnosNuevos = data.turnos;
                                const nuevasFechas = data.fechas;

                                idsTurnosNuevos.forEach((idTurnoNuevo, index) => {
                                    const nuevaFecha = nuevasFechas[index];

                                    const detallesTurno = {
                                        idTurno: Number(idTurnoNuevo),
                                        servicio: turnoSeleccionado.servicio,
                                        dia: dayjs(nuevaFecha).format('dddd'),
                                        fecha: dayjs(nuevaFecha).format('dddd, D [de] MMMM [de] YYYY'),
                                        horarioInicio: turnoSeleccionado.dias[0].horaInicio,
                                        horarioFin: turnoSeleccionado.dias[0].horaFin,
                                        nombre: turnoSeleccionado.nombre,
                                        telefono: turnoSeleccionado.telefono,
                                        categoria: turnoSeleccionado.nombreCategoria,
                                        ubicacionTienda: turnoSeleccionado.mapaUrlTienda,
                                    };

                                    enviarPdfAlServidor(detallesTurno);
                                });
                            }

                            Swal.fire(
                                'Actualización exitosa',
                                data.mensaje,
                                'success'
                            );
                            const nuevosTurnos = await cargarTurnos();
                            const turnoSeleccionadoNuevo = nuevosTurnos.find(item => item.idTurno === idTurno);
                            setTurnoSeleccionado({ ...turnoSeleccionadoNuevo });
                            setComentarioActualizado((prev) => prev + 1);
                        }
                    })
                    .catch(error => {
                        Swal.fire(
                            'Error!',
                            error.message,
                            'error'
                        );
                    });
            } catch (error) {
                Swal.fire(
                    'Error!',
                    error.message,
                    'error'
                );
            }
        }
    };

    const handleCancelar = () => {
        if (citasSeleccionadas.length > 0) {

            try {

                const payload = {
                    turnos: citasSeleccionadas
                };

                fetch(`${baseURL}/turnoCancelarPut.php`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                })

                    .then(response => response.json())
                    .then(async (data) => {
                        if (data.error) {
                            Swal.fire(
                                'Error!',
                                data.error,
                                'error'
                            );
                        } else {
                            Swal.fire(
                                'Actualización exitosa',
                                data.mensaje,
                                'success'
                            );
                            const nuevosTurnos = await cargarTurnos();
                            const turnoSeleccionadoNuevo = nuevosTurnos.find(item => item.idTurno === turnoSeleccionado.idTurno);
                            setTurnoSeleccionado({ ...turnoSeleccionadoNuevo });

                            setCancelarActualizado((prev) => prev + 1);
                        }
                    })
                    .catch(error => {
                        Swal.fire(
                            'Error!',
                            error.message,
                            'error'
                        );
                    });
            } catch (error) {
                Swal.fire(
                    'Error!',
                    error.message,
                    'error'
                );
            }

        }

    };

    const handleSelectServicio = (idServicio) => {
        setServicioSeleccionado(idServicio); // Establece el servicio seleccionado
    };

    const handleSelecetTab = (tab) => {
        setSelectedEstados(tab);
    }

    const eliminar = (idTurno) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/turnoDelete.php?idTurno=${idTurno}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            // Si el servidor devuelve un error, mostramos un mensaje de error
                            Swal.fire(
                                'Error',
                                data.error,
                                'error'
                            );
                        } else {
                            // Si la categoría se eliminó correctamente, mostramos un mensaje de éxito
                            Swal.fire(
                                '¡Eliminado!',
                                data.mensaje,
                                'success'
                            );
                            cargarTurnos();
                            handleCloseModal()
                        }
                    })
                    .catch(error => {
                        console.error('Error al eliminar contacto:', error);
                        Swal.fire(
                            'Error',
                            'Ocurrió un problema al intentar eliminar la categoría.',
                            'error'
                        );
                    });
            }
        });
    };
    const exportarExcel = () => {
        const servicioSeleccionadoNombre = servicios.find(s => s.idServicio === servicioSeleccionado)?.titulo || "Todos los servicios";

        const turnosFiltrados = filteredTurnos.filter(item => {
            if (!usuarioLegued || !usuarioLegued.idUsuario) {
                return servicioSeleccionado ? item.idServicio === servicioSeleccionado : true;
            }

            if (usuarioLegued.rol === "admin") {
                return servicioSeleccionado ? item.idServicio === servicioSeleccionado : true;
            }

            if (usuarioLegued.rol === "colaborador") {
                const serviciosColaborador = servicios
                    .filter(servicio => servicio.idUsuario === usuarioLegued.idUsuario)
                    .map(servicio => servicio.idServicio);
                return serviciosColaborador.includes(item.idServicio) && item.idServicio === servicioSeleccionado;
            }

            return false; // Fallback
        });

        const datos = turnosFiltrados.map(turno => ({
            Nombre: turno.nombre,
            DNI: turno.dni,
            Email: turno.email,
            Teléfono: turno.telefono,
            Estado: turno.estado,
            Días: turno.dias.map(dia => `${dia.dia} (${dia.horaInicio} - ${dia.horaFin})`).join(', ')
        }));

        const ws = XLSX.utils.json_to_sheet(datos);


        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Turnos");
        XLSX.writeFile(wb, `Turnos.xlsx`);
    };

    const exportarPDF = () => {
        const turnosFiltrados = filteredTurnos.filter(item => {
            if (!usuarioLegued || !usuarioLegued.idUsuario) {
                return servicioSeleccionado ? item.idServicio === servicioSeleccionado : true;
            }

            if (usuarioLegued.rol === "admin") {
                return servicioSeleccionado ? item.idServicio === servicioSeleccionado : true;
            }

            if (usuarioLegued.rol === "colaborador") {
                const serviciosColaborador = servicios
                    .filter(servicio => servicio.idUsuario === usuarioLegued.idUsuario)
                    .map(servicio => servicio.idServicio);
                return serviciosColaborador.includes(item.idServicio) && item.idServicio === servicioSeleccionado;
            }

            return false; // Fallback
        });

        const doc = new jsPDF();

        const tableColumn = ["Nombre", "DNI", "Email", "Teléfono", "Estado", "Días"];
        const tableRows = turnosFiltrados.map(turno => [
            turno.nombre,
            turno.dni,
            turno.email,
            turno.telefono,
            turno.estado,
            turno.dias.map(dia => `${dia.dia} (${dia.horaInicio} - ${dia.horaFin})`).join(', ')
        ]);

        doc.text("Turnos del Servicio", 14, 15);
        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 20,
        });
        doc.save(`Turnos.pdf`);
    };

    // Estilos personalizados para los <Select/>
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? color1 : 'white',
            color: state.isSelected ? 'white' : 'black',
        }),
        control: (provided) => ({
            ...provided,
            maxHeight: '32px',
            overflowY: 'auto',
            paddingRight: '30px',
            borderRadius: '8px',
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: '8px',

        }),
        clearIndicator: (provided) => ({
            ...provided,
            position: 'absolute',
            right: '20px',
            top: '2px',
            zIndex: 1,
            width: '50px',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            position: 'absolute',
            right: '-5px',
            top: '2px',
            zIndex: 1,
        }),
    };

    const alertAsignarSala = (turno) => {

        Swal.fire({
            icon: 'question',
            html:
                `La cita para el día <strong>${moment(turno.dias[0].dia).format('DD/MM/YYYY')}</strong> de 
                <strong>${moment(`${turno.dias[0].dia} ${turno.dias[0].horaInicio}`).format('hh:mm a')} a 
                ${moment(`${turno.dias[0].dia} ${turno.dias[0].horaFin}`).format('hh:mm a')}</strong>
                será asignada al terapeuta 
                <strong>${terapeutas.filter(terapeuta => terapeuta.idUsuario == terapeutaSeleccionado)[0].nombre}</strong>
                y se impartirá en la sala 
                <strong>${salas.filter(sala => sala.idSala == salaSeleccionada)[0].nombre}</strong>
                <br><br>
                ¿Los datos son correctos?
                 `,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText:
                'Aceptar',
            confirmButtonColor: '#14A7A3',
            cancelButtonText:
                'Modificar',
            preConfirm: () => {
                return {
                    idTurno: turno.idTurno,
                    idTerapeuta: terapeutaSeleccionado,
                }
            },
            preDeny: () => {
                return {
                    idTurno: turno.idTurno,
                }
            },
        })
            .then(async (result) => {

                if (result.isConfirmed) {
                    handleUpdateText(turnoSeleccionado.idTurno)
                }

            });
    };
    return (
        <div>
            {/* Leyenda de colores para los estatus de los turnos */}
            <div className="turnos-legend" style={{ display: 'flex', gap: '1.5rem', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#a0a0a0', border: '1px solid #888' }}></span>
                    <span>Pendiente</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#bee4fa', border: '1px solid #386def' }}></span>
                    <span>Asignado</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#e6f9ed', border: '1px solid #1a7f37' }}></span>
                    <span>Finalizado</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: 4, background: '#fee9e9', border: '1px solid #ea4b29' }}></span>
                    <span>Inactivo</span>
                </div>
            </div>
            {/* Badge mostrando el Ceseco asignado - Para coord_programa, coord_ceseco y secretaria */}
            {(usuarioLegued?.rol === 'coord_programa' || 
              usuarioLegued?.rol === 'coord_ceseco' ||
              usuarioLegued?.rol === 'secretaria') && 
             usuarioLegued?.idCategoria && (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.5rem 0.75rem',
                    background: '#f8f9fa',
                    borderRadius: '6px',
                    border: '1px solid #e9ecef',
                    fontSize: '0.875rem',
                    color: '#495057',
                    marginBottom: '1rem',
                    maxWidth: 'fit-content'
                }}>
                    <span style={{
                        fontSize: '0.875rem',
                        color: '#6c757d',
                        fontWeight: 500
                    }}>
                        Ceseco:
                    </span>
                    <span style={{
                        fontWeight: 600,
                        color: '#212529'
                    }}>
                        {usuarioLegued?.categorias && usuarioLegued.categorias.length > 0
                            ? usuarioLegued.categorias.map(c => c.categoria).join(', ')
                            : (usuarioLegued?.categoria || 
                               categorias.find(cat => cat.idCategoria === usuarioLegued?.idCategoria)?.categoria || 
                               'Sin asignar')}
                    </span>
                </div>
            )}
            <div className='grapBtns'>
                <button onClick={exportarExcel} className="excel"> <FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                <button onClick={exportarPDF} className="pdf"><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                <div className='inputsColumn' style={{ minWidth: 420, maxWidth: 480 }}>
                    <AsyncSelect {...Helper.searchTurnosAsyncSelectConfig({ setTurnoSeleccionado, setModalIsOpen, baseURL, Helper })} />
                </div>
                {loading ? (
                    <></>
                ) : usuarioLegued?.idUsuario ? (
                    <>

                        {
                            (usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'direccion') ? (
                                <>
                                    <div style={{ display: 'flex', width: '100%', maxWidth: '350px' }}>
                                        <div style={{ width: '100%', maxWidth: '350px' }}>
                                            <Select
                                                isMulti
                                                options={categorias.map(categoria => ({ value: categoria.idCategoria, label: categoria.categoria })) || []}
                                                value={categoriasFiltradas}
                                                onChange={(selectedOptions) => setCategoriasFiltradas(selectedOptions)}
                                                styles={customStyles}
                                                placeholder="Cesecos"
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                maxMenuHeight={350}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuShouldBlockScroll={true}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', width: '100%', maxWidth: '350px' }}>
                                        <div style={{ width: '100%', maxWidth: '350px' }}>
                                            <Select
                                                isMulti
                                                options={
                                                    //muestra servicios solo si escoge categoria
                                                    //servicios.filter(servicio => categoriasFiltradas.some(c => c.value === servicio.idCategoria)).map(servicio => ({ value: servicio.idServicio, label: servicio.titulo })) || []
                                                    categoriasFiltradas && categoriasFiltradas.length > 0
                                                        ? servicios
                                                            .filter(servicio => categoriasFiltradas.some(c => c.value === servicio.idCategoria))
                                                            .map(servicio => ({ value: servicio.idServicio, label: servicio.titulo }))
                                                        : servicios.map(servicio => ({ value: servicio.idServicio, label: servicio.titulo }))
                                                }
                                                value={serviciosFiltrados}
                                                onChange={(selectedOptions) => setServiciosFiltrados(selectedOptions)}
                                                styles={customStyles}
                                                placeholder="Servicios"
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                maxMenuHeight={350}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuShouldBlockScroll={true}
                                            />
                                        </div>
                                    </div>

                                    {
                                        (serviciosFiltrados.length > 0 || categoriasFiltradas.length > 0) &&
                                        <p onClick={() => { setServiciosFiltrados([]); setCategoriasFiltradas([]) }} style={{ color: 'red', textAlign: 'center', cursor: 'pointer' }}>Quitar Filtros</p>
                                    }

                                    <div style={{ display: 'flex', gap: '0.5rem', marginLeft: '1rem', marginBottom: '1rem' }}>
                                        {Helper.estadoFiltros.map(filtro => (
                                            <button
                                                key={filtro.key}
                                                className={selectedEstados.includes(filtro.key) ? 'btnSelected' : 'btnNoSelected'}
                                                style={{
                                                    background: selectedEstados.includes(filtro.key) ? filtro.bg : '#f5f5f5',
                                                    color: selectedEstados.includes(filtro.key) ? filtro.color : '#333',
                                                    border: `1px solid ${filtro.border}`,
                                                    borderRadius: 8,
                                                    padding: '0.5rem 1.2rem',
                                                    fontWeight: 600,
                                                    boxShadow: selectedEstados.includes(filtro.key) ? `0 2px 8px ${filtro.bg}66` : 'none',
                                                    transition: 'all 0.2s',
                                                }}
                                                onClick={() => {
                                                    setSelectedEstados(prev =>
                                                        prev.includes(filtro.key)
                                                            ? prev.filter(e => e !== filtro.key)
                                                            : [...prev, filtro.key]
                                                    );
                                                }}
                                            >
                                                {filtro.label}
                                            </button>
                                        ))}
                                    </div>

                                </>
                            ) : (<></>)
                        }
                        {

                            (usuarioLegued?.rol === 'coord_programa' || 
                             usuarioLegued?.rol === 'coord_ceseco' ||
                             usuarioLegued?.rol === 'secretaria') && (
                                <>
                                    <div style={{ display: 'flex', width: '100%', maxWidth: '350px' }}>
                                        <div style={{ width: '100%', maxWidth: '350px' }}>
                                            <Select
                                                isMulti
                                                options={servicios
                                                    .filter(servicio => {
                                                        // Verificar que el servicio pertenezca a uno de los Cesecos asignados
                                                        const perteneceACeseco = usuarioLegued?.idCategorias?.includes(servicio.idCategoria) ||
                                                                                servicio.idCategoria === usuarioLegued.idCategoria;
                                                        
                                                        if (!perteneceACeseco) return false;
                                                        
                                                        // Para coord_ceseco y secretaria: mostrar todos los servicios de sus Cesecos
                                                        if (usuarioLegued?.rol === 'coord_ceseco' || usuarioLegued?.rol === 'secretaria') {
                                                            return true;
                                                        }
                                                        
                                                        // Para coord_programa: solo servicios asignados directamente
                                                        if (usuarioLegued?.rol === 'coord_programa') {
                                                            return usuarioLegued?.idServicios?.includes(servicio.idServicio) ||
                                                                   usuarioLegued?.idServicio === servicio.idServicio;
                                                        }
                                                        
                                                        // Para admin y direccion: todos
                                                        return ['admin', 'direccion'].includes(usuarioLegued?.rol);
                                                    })
                                                    .map(servicio => ({ value: servicio.idServicio, label: servicio.titulo })) || []}
                                                value={serviciosFiltrados}
                                                onChange={(selectedOptions) => setServiciosFiltrados(selectedOptions)}
                                                styles={customStyles}
                                                placeholder="Servicios"
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                maxMenuHeight={350}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuShouldBlockScroll={true}
                                            />
                                        </div>
                                    </div>
                                    {
                                        (serviciosFiltrados.length > 0 || categoriasFiltradas.length > 0) &&
                                        <p onClick={() => { setServiciosFiltrados([]); setCategoriasFiltradas([]) }} style={{ color: 'red', textAlign: 'center', cursor: 'pointer' }}>Quitar Filtros</p>
                                    }

                                </>
                            )
                        }
                        {/* {usuarioLegued?.rol === 'admin' ? (
                            <>
                                {
                                    servicios?.filter(item => usuarioLegued.rol === 'admin' || item.idUsuario === usuarioLegued.idUsuario).map(item => {
                                        const turnosPorServicio = turnos?.filter(turno => turno.idServicio === item.idServicio).length; // Calcular la cantidad de turnos para el servicio
                                        return (
                                            <button
                                                key={item.idServicio}
                                                className={servicioSeleccionado === item.idServicio ? 'btnSelected' : 'btnNoSelected'}
                                                onClick={() => handleSelectServicio(item.idServicio)}
                                            >
                                                ({turnosPorServicio})  <span>{item.titulo} </span>
                                            </button>
                                        );
                                    })
                                }
                            </>
                        ) : usuarioLegued?.rol === 'colaborador' ? (
                            <>
                                {
                                    servicios?.filter(item => usuarioLegued.rol === 'admin' || item.idUsuario === usuarioLegued.idUsuario).map(item => {
                                        const turnosPorServicio = turnos?.filter(turno => turno.idServicio === item.idServicio).length; // Calcular la cantidad de turnos para el servicio
                                        return (
                                            <button
                                                key={item.idServicio}
                                                className={servicioSeleccionado === item.idServicio ? 'btnSelected' : 'btnNoSelected'}
                                                onClick={() => handleSelectServicio(item.idServicio)}
                                            >
                                                ({turnosPorServicio})  <span>{item.titulo} </span>
                                            </button>
                                        );
                                    })
                                }
                            </>
                        ) : (
                            <></>
                        )} */}
                    </>
                ) : (
                    <>
                        {
                            servicios?.map(item => {
                                const turnosPorServicio = turnos?.filter(turno => turno.idServicio === item.idServicio).length; // Calcular la cantidad de turnos para el servicio
                                return (
                                    <button
                                        key={item.idServicio}
                                        className={servicioSeleccionado === item.idServicio ? 'btnSelected' : 'btnNoSelected'}
                                        onClick={() => handleSelectServicio(item.idServicio)}
                                    >
                                        ({turnosPorServicio})  <span>{item.titulo} </span>
                                    </button>
                                );
                            })
                        }
                    </>
                )}

            </div>
            {/* Información de filtros activos */}
            {(categoriasFiltradas.length > 0 || serviciosFiltrados.length > 0) && (
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.75rem',
                    marginBottom: '1rem',
                    padding: '0.75rem 1rem',
                    background: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef'
                }}>
                    {categoriasFiltradas.length > 0 && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: '0.5rem 0.75rem',
                            background: '#e7f3ff',
                            borderRadius: '6px',
                            fontSize: '0.875rem'
                        }}>
                            <span style={{ fontWeight: 600, color: '#0066cc' }}>Cesecos:</span>
                            <span style={{ color: '#333' }}>{categoriasFiltradas.map(obj => obj.label).join(', ')}</span>
                        </div>
                    )}
                    {serviciosFiltrados.length > 0 && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: '0.5rem 0.75rem',
                            background: '#fff3cd',
                            borderRadius: '6px',
                            fontSize: '0.875rem'
                        }}>
                            <span style={{ fontWeight: 600, color: '#856404' }}>Servicios:</span>
                            <span style={{ color: '#333' }}>
                                {usuarioLegued?.rol === 'coord_programa' || 
                                 usuarioLegued?.rol === 'coord_ceseco' || 
                                 usuarioLegued?.rol === 'secretaria' ||
                                 usuarioLegued?.rol === 'direccion'
                                    ? (serviciosFiltrados.length === servicios.filter(servicio => {
                                        const perteneceACeseco = usuarioLegued?.idCategorias?.includes(servicio.idCategoria) ||
                                                                servicio.idCategoria === usuarioLegued.idCategoria;
                                        if (!perteneceACeseco) return false;
                                        
                                        if (usuarioLegued?.rol === 'coord_ceseco' || usuarioLegued?.rol === 'secretaria') {
                                            return true;
                                        }
                                        
                                        if (usuarioLegued?.rol === 'coord_programa') {
                                            return usuarioLegued?.idServicios?.includes(servicio.idServicio) ||
                                                   usuarioLegued?.idServicio === servicio.idServicio;
                                        }
                                        
                                        return ['admin', 'direccion'].includes(usuarioLegued?.rol);
                                    }).length 
                                        ? 'Todos los servicios' 
                                        : serviciosFiltrados.map(obj => obj.label).join(', '))
                                    : serviciosFiltrados.map(obj => obj.label).join(', ')
                                }
                            </span>
                        </div>
                    )}
                </div>
            )}
            {/* </div> */}
            <Calendar
                localizer={localizer}
                events={events} // Usar los eventos filtrados
                startAccessor="start"
                endAccessor="end"
                onSelectEvent={handleSelectEvent}
                // onSelectSlot={handleSelectSlot}
                selectable
                views={['month', 'week', 'day']}
                defaultView="week"
                style={{ height: 550 }}
                components={{
                    event: CustomEvent,
                }}
                messages={messages}
                eventPropGetter={(event) => ({
                    style: event.style // Usa el estilo definido en el evento
                })}
            />

            {/* Modal para mostrar los detalles del turno seleccionado */}
            {turnoSeleccionado && (
                <TurnoModal
                    isOpen={modalIsOpen}
                    onClose={handleCloseModal}
                    turnoSeleccionado={turnoSeleccionado}
                    nombre={nombre}
                    setNombre={setNombre}
                    telefono={telefono}
                    setTelefono={setTelefono}
                    motivoInactivo={motivoInactivo}
                    setMotivoInactivo={setMotivoInactivo}
                    nuevaFecha={nuevaFecha}
                    setNuevaFecha={setNuevaFecha}
                    periodicidad={periodicidad}
                    setPeriodicidad={setPeriodicidad}
                    nuevaHoraInicio={nuevaHoraInicio}
                    setNuevaHoraInicio={setNuevaHoraInicio}
                    nuevaHoraFin={nuevaHoraFin}
                    setNuevaHoraFin={setNuevaHoraFin}
                    nuevoComentario={nuevoComentario}
                    setNuevoComentario={setNuevoComentario}
                    comentarioActualizado={comentarioActualizado}
                    cancelarActualizado={cancelarActualizado}
                    nuevoEstado={nuevoEstado}
                    setNuevoEstado={setNuevoEstado}
                    categorias={categorias}
                    categoriaSeleccionada={categoriaSeleccionada}
                    setCategoriaSeleccionada={setCategoriaSeleccionada}
                    servicioSeleccionado={servicioSeleccionado}
                    setServicioSeleccionado={setServicioSeleccionado}
                    terapeutaSeleccionado={terapeutaSeleccionado}
                    setTerapeutaSeleccionado={setTerapeutaSeleccionado}
                    salaSeleccionada={salaSeleccionada}
                    setSalaSeleccionada={setSalaSeleccionada}
                    citasSeleccionadas={citasSeleccionadas}
                    setCitasSeleccionadas={setCitasSeleccionadas}
                    alertAsignarSala={alertAsignarSala}
                    handleUpdateText={handleUpdateText}
                    handleUpdateDate={handleUpdateDate}
                    handleInsertComment={handleInsertComment}
                    handleCancelar={handleCancelar}
                />
            )}
        </div>
    );
}
